import { FC } from "react";
import { InView } from "react-intersection-observer";
import { PopularBrands } from "src/organisms/PopularBrands";
import { ContentMobileFullscreen } from "src/atoms/Content";
import { Wrapper } from "./PopularBrands.styled";
import { PLPType } from "src/types/PLPType.d";

interface Props {
  localeGenderId: string;
  genderId: string;
  excludeSlug?: string;
  viewAllLink?: string;
  plpType?: PLPType;
}

const PLP_PAGE_TYPE: Record<PLPType, string> = {
  [PLPType.BRAND_PLP]: "brand",
  [PLPType.ICONS_PLP]: "icons",
  [PLPType.CATEGORY_PLP]: "category",
  [PLPType.NEW_IN]: "new_in",
  [PLPType.HOT_DEALS]: "hot_deals",
  [PLPType.CLEARANCE_PLP]: "clearance",
  [PLPType.DESIGNER_PLP]: "designer",
  [PLPType.COLLECTIONS_PLP]: "collection",
  [PLPType.SEARCH_PLP]: "search_catalog",
  [PLPType.SHOP_TYPE]: "shoptype",
};

const PopularBrandsWrapper: FC<Props> = ({
  localeGenderId,
  genderId,
  excludeSlug,
  viewAllLink,
  plpType,
}): JSX.Element => {
  const pageType = plpType ? `${PLP_PAGE_TYPE[plpType]}_` : "";

  return (
    <InView rootMargin={"100px 0px 0px 0px"}>
      {({ inView, ref }) => (
        <Wrapper ref={ref}>
          <ContentMobileFullscreen>
            {inView && genderId && (
              <PopularBrands
                localeGenderId={localeGenderId}
                genderId={genderId as "women" | "men" | "kids"}
                excludeSlug={excludeSlug}
                viewAllLink={viewAllLink}
                pageName={`${pageType}product_listing_page`}
              />
            )}
          </ContentMobileFullscreen>
        </Wrapper>
      )}
    </InView>
  );
};

export { PopularBrandsWrapper };
